import { MessageCircle, Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Reveal from "./Reveal";
import { FAQS, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_MSG_URL } from "./data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-slate-50 py-16 sm:py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.4fr] lg:gap-16 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-sapphire">Good to know</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Questions, answered
          </h2>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-600 sm:text-base">
            Everything Siliguri homeowners and businesses usually ask before booking. Still unsure? We reply on
            WhatsApp within minutes during working hours.
          </p>
          <div className="mt-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
            <p className="text-sm font-bold text-slate-900">Talk to the team directly</p>
            <div className="mt-4 flex flex-wrap gap-3">
              <a
                data-testid="faq-call-button"
                href={PHONE_TEL}
                className="inline-flex items-center gap-2 rounded-full bg-sapphire px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-sapphire-dark"
              >
                <Phone className="h-4 w-4" />
                {PHONE_DISPLAY}
              </a>
              <a
                data-testid="faq-whatsapp-button"
                href={WHATSAPP_MSG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border-2 border-whatsapp px-5 py-2.5 text-sm font-bold text-whatsapp-dark transition-colors hover:bg-whatsapp hover:text-white"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp us
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="mb-3 rounded-2xl border border-slate-200 bg-white px-5 shadow-sm"
              >
                <AccordionTrigger className="py-5 text-left text-sm font-bold text-slate-900 hover:no-underline sm:text-base">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
